var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6187 2.21436C12.2557 1.92855 11.7443 1.92855 11.3813 2.21436L3.38131 8.51436C3.14053 8.70398 3 8.99353 3 9.3V19.2C3 19.9386 3.28968 20.6495 3.80921 21.1755C4.32916 21.7019 5.03703 22 5.77778 22H8V12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V22H18.2222C18.963 22 19.6708 21.7019 20.1908 21.1755C20.7103 20.6495 21 19.9386 21 19.2V9.3C21 8.99353 20.8595 8.70398 20.6187 8.51436L12.6187 2.21436ZM14 22V13H10V22H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f0aa2ff19b3741ec78bcb0a4228c8cf1.svg";
export { ForwardRef as ReactComponent };